import React from "react";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";

const Treat = () => {
  return (
    <div>
      <Navbar />
      <div className="mx-36">
        <div className="text-black mt-5">
          <Link to="/mainarticle">
            <button className="flex gap-1 px-4 py-3 rounded-xl w-fit"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
            </svg>
              Back
            </button>
          </Link>
        </div>
          <h1 className="text-3xl text-[#295700] font-serif font-bold text-center">
            HOW TO TREAT INSOMNIA
          </h1>
        <div className="bg-[#DCAE96] px-4 py-5 mb-20">
          <div className="class= flex justify-center">
            <img
              src="https://res.cloudinary.com/dtd0nwvyd/image/upload/v1700672590/article_list_1_jqkryj.png"
              alt="Picture of an insomnia patient"
            />
          </div>
          <blockquote className="text-center font-bold p-5">
            "Through the darkest nights of insomnia, remember that the dawn of
            restful sleep is just a step away. Keep seeking solutions, for with
            every effort, you bring the promise of a peaceful slumber closer."
          </blockquote>
          <p className="pb-5">
            Treating insomnia often involves a combination of lifestyle changes,
            behavioural strategies and in some cases, medical interventions. Here
            are some steps you can take to address insomnia...
          </p>
          <p className="pb-5">
            Sometimes, insomnia can be a symptom of an underlying medical or
            psychological condition. If such conditions are identified, the
            healthcare professional will address them.
          </p>
          <ol className="list-decimal mx-10">
            <li className="pb-5">
              <span className="font-semibold">Personal Insight:</span>Choose a
              Bedtime and Wake-Up Time: Select a bedtime and wake-up time that
              aligns with your natural sleep preferences and daily routine. Aim
              for 7-9 hours of sleep per night.Be Consistent Every Day: Try to go
              to bed and wake up at the same time every day, even on weekends.
              Consistency reinforces your body's sleep-wake cycle.Avoid Drastic
              Changes: Gradually adjust your sleep schedule if needed. Shift your
              bedtime and wake-up time by 15-30 minutes every few days until you
              reach your desired schedule.Use an Alarm: Set an alarm to remind you
              when it's time to start winding down and prepare for bed. This helps
              signal your body that sleep is approaching.
            </li>
            <li className="pb-5">
              <span className="font-semibold">
                Consult a healthcare professional (Recognize the Need):
              </span>
              If you've been struggling with sleep difficulties for several weeks
              and it's affecting your daily functioning, it's a sign to seek
              professional help.Primary Care Physician: Start by scheduling an
              appointment with your primary care physician (PCP). They can
              evaluate your overall health and may provide initial guidance or
              refer you to a sleep specialist if needed.Sleep Specialist: If your
              PCP suspects a more complex sleep disorder, they might refer you to
              a sleep specialist. Sleep specialists are doctors with expertise in
              diagnosing and treating sleep-related issues.
            </li>
            <li className="pb-5">
              <span className="font-semibold">Limit Exposure to Screens:</span>{" "}
              Avoid electronic devices like phones, tablets, and computers before
              bed, as the blue light emitted can interfere with your sleep cycle.
            </li>
            <li className="pb-5">
              <span className="font-semibold">
                Create a Comfortable Sleep Environment:
              </span>
              Make sure your bedroom is conducive to sleep. This includes keeping
              the room dark, quiet, and at a comfortable temperature.
            </li>
            <li className="pb-5">
              <span className="font-semibold">Limit Daytime Naps: </span>While
              short power naps can be refreshing, long daytime naps can disrupt
              your nighttime sleep. If you need to nap, aim for about 20-30
              minutes.
            </li>
            <li className="pb-5">
              <span className="font-semibold">Exercise Regularly:</span> Engaging
              in regular physical activity can help improve sleep quality.
              However, try to avoid intense exercise close to bedtime.
            </li>
            <li className="pb-5">
              <span className="font-semibold">Watch Your Diet:</span> Avoid heavy,
              large meals before bedtime. Also, consider limiting caffeine and
              alcohol intake, especially in the evening.
            </li>
            <li className="pb-5">
              <span className="font-semibold">Manage Stress and Anxiety:</span>
              Practice stress-reduction techniques, such as mindfulness, yoga, or
              progressive muscle relaxation, to help calm your mind before bed.
            </li>
            <li className="pb-5">
              <span className="font-semibold">
                Cognitive Behavioral Therapy for Insomnia (CBT-I):
              </span>
              This structured therapy focuses on changing behaviors and thought
              patterns that contribute to insomnia. It can be highly effective and
              is often recommended by healthcare professionals.
            </li>
            <li className="pb-5">
              <span className="font-semibold">Personal Insight:</span> Staring at
              the clock can increase anxiety about sleep. If you can't sleep, get
              out of bed and engage in a relaxing activity until you feel sleepy.
            </li>
            <li className="pb-5">
              <span className="font-semibold">Consider Professional Help:</span>{" "}
              If your insomnia persists and affects your daily functioning,
              consider seeking help from a healthcare provider. They might
              recommend medications or other interventions.
            </li>
          </ol>
          <p className="pb-5">
            Remember that everyone's situation is unique, so it's important to
            find strategies that work best for you. If your insomnia is chronic or
            severe, consulting a medical professional is crucial for proper
            diagnosis and treatment.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Treat;
